import React from "react";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useLanguage } from "@/context/LanguageContext";

export const CartDrawer = () => {
  const { items, setQty, remove, total, open, setOpen } = useCart();
  const { t, lang } = useLanguage();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={() => setOpen(false)}
        data-testid="cart-backdrop"
      />
      <aside
        className={`absolute top-0 bottom-0 ${lang === "ar" ? "left-0" : "right-0"} w-full sm:w-[420px] bg-[#0A0A0B] border-${lang === "ar" ? "r" : "l"} border-[#27272A] shadow-2xl flex flex-col`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-[#27272A]">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#9CA3AF]">M16</div>
            <h2 className="font-display text-2xl">{t("yourCart")}</h2>
          </div>
          <button onClick={() => setOpen(false)} data-testid="cart-close-btn" className="p-2 hover:text-[#D4AF37]">
            <X size={22} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
          {items.length === 0 && (
            <div className="text-center py-20">
              <div className="text-[#9CA3AF] text-sm">{t("emptyCart")}</div>
              <button
                onClick={() => setOpen(false)}
                data-testid="empty-cart-continue-btn"
                className="mt-6 btn-outline-gold px-5 py-2 rounded-full text-sm"
              >
                {t("continueShopping")}
              </button>
            </div>
          )}

          {items.map((it) => (
            <div key={it.product_id} className="flex gap-4 p-3 border border-[#27272A] rounded-xl" data-testid={`cart-item-${it.product_id}`}>
              <img src={it.image_url} alt="" className="w-20 h-20 object-cover rounded-lg" />
              <div className="flex-1">
                <div className="text-sm leading-snug mb-2">{lang === "ar" ? it.name_ar : it.name_en}</div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1 border border-[#27272A] rounded-full">
                    <button onClick={() => setQty(it.product_id, it.quantity - 1)} data-testid={`cart-decrease-${it.product_id}`} className="p-2 hover:text-[#D4AF37]">
                      <Minus size={14} />
                    </button>
                    <span className="num-ltr px-2 text-sm">{it.quantity}</span>
                    <button onClick={() => setQty(it.product_id, it.quantity + 1)} data-testid={`cart-increase-${it.product_id}`} className="p-2 hover:text-[#D4AF37]">
                      <Plus size={14} />
                    </button>
                  </div>
                  <button onClick={() => remove(it.product_id)} data-testid={`cart-remove-${it.product_id}`} className="text-[#9CA3AF] hover:text-red-400">
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
              <div className="text-[#D4AF37] font-display text-sm num-ltr self-start">
                {(it.price * it.quantity).toFixed(2)}
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[#27272A] p-6 space-y-4 bg-[#0A0A0B]">
            <div className="flex items-center justify-between">
              <span className="text-[#9CA3AF] text-sm">{t("total")}</span>
              <span className="font-display text-2xl text-[#D4AF37] num-ltr">
                {total.toFixed(2)} <span className="text-sm text-[#9CA3AF]">{t("currency")}</span>
              </span>
            </div>
            <Link
              to="/checkout"
              onClick={() => setOpen(false)}
              data-testid="cart-checkout-btn"
              className="btn-gold w-full py-3 rounded-full text-center block"
            >
              {t("checkout")}
            </Link>
          </div>
        )}
      </aside>
    </div>
  );
};
